import React, { useState } from 'react';
import Layout from '../components/Layout';

const SECCIONES = [
  {
    id: 'acceso', icon: '🔐', titulo: 'Acceso al sistema',
    contenido: `Al ingresar a http://localhost:3000 ingresa con tu correo y contraseña. La sesión dura 8 horas.

Si pierdes acceso, un superadmin debe restablecer la contraseña desde el módulo de Usuarios.`
  },
  {
    id: 'roles', icon: '👤', titulo: 'Roles de usuario',
    tabla: {
      cabeceras: ['Rol', 'Descripción', 'Permisos clave'],
      filas: [
        ['superadmin', 'Acceso total', 'Eliminar masivo, gestionar usuarios, limpiar infraestructura'],
        ['admin', 'Gestión operativa completa', 'Crear, editar, cobrar, importar catálogos'],
        ['operador', 'Consulta y operación básica', 'Ver clientes, registrar pagos, crear tickets'],
        ['tecnico', 'Soporte técnico', 'Tickets, agenda y clientes'],
      ]
    }
  },
  {
    id: 'clientes', icon: '👥', titulo: 'Clientes',
    contenido: `Módulo central del sistema con integración directa al MikroTik.

📌 Crear cliente → se crea automáticamente en MikroTik
📌 Editar velocidad/perfil → se actualiza en MikroTik
📌 Suspender → se deshabilita en MikroTik
📌 Activar → se habilita en MikroTik
📌 Eliminar → se elimina completamente del MikroTik

📌 Estado "Inactivo temporal"
Para clientes que pausan el servicio (colegios, temporadas). No genera cobros automáticos mientras esté en ese estado.

📌 Prorrateo
Calcula el cobro del primer mes proporcional según la fecha de instalación.

📌 Precio especial
Si un cliente paga diferente al precio del plan, asigna un precio especial individual.`,
    tabla: {
      cabeceras: ['Estado', 'Significado'],
      filas: [
        ['Activo', 'Al día con pagos'],
        ['Moroso', 'Cobros vencidos sin pagar'],
        ['Suspendido', 'Servicio cortado temporalmente'],
        ['Inactivo temporal', 'Sin contrato activo — sin cobros automáticos'],
        ['Retirado', 'Ya no es cliente'],
      ]
    }
  },
  {
    id: 'cartera', icon: '💳', titulo: 'Cartera',
    contenido: `Módulo de cobros de suscripciones mensuales.

📌 Generar cobros del mes
1. Seleccionar mes y año
2. Clic en ⚡ Generar cobros
3. Clientes en Inactivo temporal o Retirado NO generan cobro

📌 Pagos parciales (abonos)
Si el cliente paga menos del total, el cobro queda como "Abono parcial" (morado).
El saldo se acumula hasta completar el total → pasa a Pagado.

📌 Comprobante de pago
Se puede adjuntar foto del comprobante para pagos digitales (Nequi, Daviplata, etc).

📌 Inscripción
Cobro de instalación separado del mensual — usar botón + Inscripción.`,
    tabla: {
      cabeceras: ['Estado', 'Color', 'Descripción'],
      filas: [
        ['Pendiente', 'Amarillo', 'Generado, no pagado'],
        ['Abono parcial', 'Morado', 'Pago incompleto recibido'],
        ['Pagado', 'Verde', 'Pago completo registrado'],
        ['Vencido', 'Rojo', 'Pasó la fecha sin pagar'],
      ]
    }
  },
  {
    id: 'transacciones', icon: '💰', titulo: 'Dinero',
    contenido: `Todo el dinero del negocio en una pantalla. Antes eran dos —Ingresos/Egresos
y Caja diaria— y había que escribir lo mismo en las dos.

📌 Lo que ENTRA no se escribe: lo calcula el sistema
El dinero que entra sale solo de donde ya está registrado:
• Mensualidades — de los cobros que marcas pagados en Cartera
• Instalaciones — de los pagos de inscripción
• Ventas y servicios — del módulo Ventas
• Revendedores — de lo que te pagan

Por eso los ingresos son de solo lectura aquí. Si un ingreso está mal, se corrige donde
nació: en el pago o en la venta. Así nunca pueden discrepar, y si anulas una venta su
ingreso desaparece solo.

⚠ Un cobro generado y NO pagado no aparece como ingreso. Eso es cartera pendiente,
no plata que entró.

📌 Lo que SALE sí lo registras tú
Con el botón «+ Registrar gasto»: en qué se gastó, cuánto, cuándo, la categoría y cómo
se pagó. No hay ningún documento del que el sistema pueda deducir un gasto, por eso este
sí se escribe.

📌 Las tres cifras de arriba
• Entró — todo el dinero que llegó en el periodo
• Salió — los gastos
• Queda — la diferencia

Debajo se ve de dónde vino la plata y en qué se fue, con barras para comparar de un
vistazo. Y abajo el detalle movimiento por movimiento.`
  },
  {
    id: 'ventas', icon: '🛍️', titulo: 'Ventas y Servicios',
    contenido: `Registro de ventas de productos del catálogo o servicios esporádicos.

📌 Nueva venta
1. Seleccionar cliente o ingresar nombre manual
2. Buscar producto del catálogo (filtro por proveedor y categoría)
3. Ajustar cantidad, precio y descuento
4. Guardar

📌 Formatos de impresión
• 🖨️ Hoja A4 — documento formal con logo de la empresa
• 🧾 Rollo POS — formato 72mm para impresora térmica
• ⬇ Excel — exportar listado del mes
• 📄 PDF — exportar listado del mes`
  },
  {
    id: 'cotizaciones', icon: '📋', titulo: 'Cotizaciones',
    contenido: `Genera cotizaciones formales con productos del catálogo.

📌 Nueva cotización
1. Seleccionar o ingresar datos del cliente
2. Agregar productos con el buscador (filtra por proveedor y categoría)
3. Ajustar cantidades, precios y descuentos generales
4. Guardar y ver cotización

📌 Imprimir
Documento profesional con logo, tabla de productos y totales.

📌 Convertir en venta
Desde el detalle de una cotización aprobada.`,
    tabla: {
      cabeceras: ['Estado', 'Descripción'],
      filas: [
        ['Borrador', 'En elaboración'],
        ['Enviada', 'Enviada al cliente'],
        ['Aprobada', 'Cliente aceptó'],
        ['Rechazada', 'Cliente rechazó'],
        ['Convertida', 'Ya se hizo la venta'],
      ]
    }
  },
  {
    id: 'catalogo', icon: '📦', titulo: 'Catálogo de Productos',
    contenido: `Catálogo dual Tecnoplaza (azul) y Metro (rosado) con márgenes automáticos.

📌 Importar Metro
1. Clic en 📋 Actualizar Metro
2. Subir el archivo PDF
3. El sistema procesa automáticamente (30-60 segundos)

📌 Importar Tecnoplaza
1. Clic en 📋 Actualizar Tecnoplaza
2. Subir el archivo PDF directamente

📌 Buscador (en Ventas y Cotizaciones)
Tres niveles de filtro: texto por nombre/SKU, proveedor y categoría.`,
    tabla: {
      cabeceras: ['Costo', 'Margen'],
      filas: [
        ['Hasta $50.000', '35%'],
        ['$50.001 – $100.000', '30%'],
        ['$100.001 – $300.000', '25%'],
        ['$300.001 – $600.000', '22%'],
        ['$600.001 – $1.000.000', '20%'],
        ['$1.000.001 – $2.000.000', '18%'],
        ['$2.000.001 – $5.000.000', '15%'],
        ['Más de $5.000.000', '12%'],
      ]
    }
  },
  {
    id: 'revendedores', icon: '🤝', titulo: 'Revendedores',
    contenido: `💡 Lógica: Los revendedores generan INGRESOS — Linkus les cobra una tarifa mensual por cada cliente en su red.

📌 Registrar revendedor
Nombre, NIT, contacto, tarifa por cliente y día de cobro.

📌 Vista detalle
• Tab Clientes: asignar clientes al revendedor
• Tab Cobros: generar y registrar cobros mensuales

📌 Generar cobros
Seleccionar mes y clic en ⚡ Generar cobros.`
  },
  {
    id: 'proveedores', icon: '🌐', titulo: 'Proveedores de Red',
    contenido: `💡 Lógica inversa a Revendedores: Los proveedores generan COSTOS — Linkus les paga por cada cliente en su red.

📌 Vista detalle — 3 tabs
• Clientes: asignar/retirar clientes de la red del proveedor
• Cobros: generar pago mensual y registrar cuando se paga
• Rentabilidad: ingreso del cliente vs. costo del proveedor vs. utilidad neta

📌 Ejemplo
Cliente paga a Linkus: $55.000/mes
Linkus paga al proveedor: $20.000/mes
Utilidad neta: $35.000/mes (64% de margen)`
  },
  {
    id: 'equipos', icon: '🔌', titulo: 'Equipos (dentro de Red)',
    contenido: `Todos los aparatos de la red en una sola lista: los de las torres y los que
están en casa de los clientes. Está en Red → 🔌 Equipos.

Antes había dos módulos separados —Infraestructura y Equipos— que leían la misma tabla y
mostraban cosas distintas. Ahora es uno solo.

📌 📡 Traer del MikroTik
Le pregunta al router qué equipos ve. Los que reconoce por el nombre (AP1 CARBONERO, PTP
CALOTO) los agrega solos. Los que no —los radios de cliente llevan el nombre de la
persona— se muestran con una casilla para que marques cuáles son tuyos y les pongas el
tipo. Los de la red 172.100.x.x vienen ya marcados como equipo de cliente.

📌 🔎 Descubrir equipos de clientes
Averigua la IP de cada cliente y qué equipo tiene instalado:
• Los radios se anuncian al router, así que trae modelo y firmware exactos
• Las ONU de fibra no se anuncian, pero su sesión PPPoE reporta la MAC

Esto corre solo cada 3 horas. El botón es para forzarlo.

📌 La marca se aprende
Si un equipo queda sin marca, corrígela a mano en UNO solo de ese fabricante: los demás
con la misma MAC inicial la toman solos en la próxima lectura.`,
    tabla: {
      cabeceras: ['Tipo', 'Qué es'],
      filas: [
        ['AP', 'Antena en la torre que da servicio a varios clientes'],
        ['PTP', 'Enlace punto a punto entre dos torres'],
        ['CPE', 'Equipo que recibe un enlace'],
        ['CR', 'Radio en casa del cliente (Ubiquiti)'],
        ['ONU', 'Equipo de fibra en casa del cliente'],
        ['RB', 'Router MikroTik'],
      ]
    }
  },
  {
    id: 'mikrotik', icon: '🔧', titulo: 'MikroTik',
    contenido: `Integración directa con el RouterBoard RB4011.

📌 Configuración de conexión
• IP del RouterBoard
• Puerto API: 589
• Usuario y contraseña de la API
• Marcar Integración activa ✅
• NO marcar SSL

📌 Importar clientes
• Importar clientes nuevos: agrega sin borrar existentes
• Reimportar desde cero: borra todo y reimporta con planes automáticos

📌 Asignación automática de planes
• PPPoE (fibra): según perfil de velocidad
• Simple Queue (radio): según velocidad en bps

📌 Sincronización
El sistema es la fuente de verdad:
• Crear cliente → se crea en MikroTik
• Editar velocidad → se actualiza en MikroTik
• Suspender → se deshabilita en MikroTik
• Eliminar → se elimina del MikroTik`
  },
  {
    id: 'tickets', icon: '🎫', titulo: 'Tickets de Soporte',
    contenido: `Sistema de seguimiento de reportes y solicitudes de clientes.

📌 Crear ticket
1. Seleccionar cliente
2. Tipo de problema, prioridad y descripción
3. Asignar técnico (opcional)

📌 Seguimiento
Agregar comentarios y cambiar estado desde el detalle del ticket.`,
    tabla: {
      cabeceras: ['Estado', 'Descripción'],
      filas: [
        ['Abierto', 'Recién creado, sin atender'],
        ['En proceso', 'Técnico trabajando'],
        ['Resuelto', 'Problema solucionado'],
        ['Cerrado', 'Ticket finalizado'],
      ]
    }
  },
  {
    id: 'agenda', icon: '📅', titulo: 'Agenda',
    contenido: `Calendario de visitas técnicas, instalaciones y recordatorios.

📌 Vistas disponibles
• Vista mensual: calendario completo
• Vista semanal: detalle de la semana

📌 Crear evento
1. Clic en un día del calendario o + Nuevo evento
2. Título, fecha/hora inicio y fin
3. Tipo: instalación, soporte, reunión, otro
4. Asociar a cliente y/o ticket
5. Asignar técnico responsable`,
    tabla: {
      cabeceras: ['Estado', 'Descripción'],
      filas: [
        ['Pendiente', 'Por realizar'],
        ['En proceso', 'En ejecución'],
        ['Completado', 'Realizado exitosamente'],
        ['Cancelado', 'No se realizó'],
      ]
    }
  },
  {
    id: 'reportes', icon: '📊', titulo: 'Reportes',
    contenido: `Vista ejecutiva del negocio con gráficas e indicadores clave.

📌 KPIs principales (por mes)
• Clientes activos, morosos y suspendidos
• Total cobrado en suscripciones vs. pendiente
• Ventas y servicios del mes
• Balance (ingresos − egresos)

📌 Gráficas
• Ingresos vs. Egresos anual — barras por mes
• Clientes por plan — distribución en torta
• Cartera del mes — pagados, pendientes y vencidos

📌 Rentabilidad por Proveedor de Red
• Card por proveedor: ingresos, costos y utilidad total
• Detalle expandible: tabla por cliente con margen individual`
  },
  {
    id: 'usuarios', icon: '👤', titulo: 'Usuarios',
    contenido: `Solo admin y superadmin pueden gestionar usuarios.

📌 Crear usuario
Nombre, correo, contraseña y rol.

📌 Desactivar usuario
Toggle Activo/Inactivo — el usuario no puede ingresar pero sus registros se conservan.`,
    tabla: {
      cabeceras: ['Rol', 'Acceso'],
      filas: [
        ['superadmin', 'Todo sin restricciones'],
        ['admin', 'Gestión operativa completa'],
        ['operador', 'Consulta y operaciones básicas'],
        ['tecnico', 'Tickets, agenda y clientes'],
      ]
    }
  },
  {
    id: 'backup', icon: '💾', titulo: 'Copia de seguridad',
    contenido: `📌 Descargar backup
Ve a Configuración → ⬇ Descargar backup
Genera un archivo .dump con toda la base de datos. Guárdalo en USB o Google Drive.

📌 Restaurar backup
Ve a Configuración → ⬆ Restaurar backup
Selecciona el archivo .dump y restaura toda la BD.
⚠️ Pide confirmación — esta acción reemplaza todos los datos actuales.

Hacer backup regularmente especialmente antes de cambios importantes.`
  },
  {
    id: 'comandos', icon: '⚙️', titulo: 'Comandos técnicos (Docker)',
    contenido: `Comandos útiles para mantenimiento en PowerShell:

▶ Ver estado de contenedores:
docker compose ps

▶ Reiniciar sistema:
docker compose restart

▶ Reconstruir tras actualización:
docker compose build --no-cache
docker compose up -d

▶ Ver logs del backend:
docker compose logs backend -f

▶ Backup manual:
docker exec telecom_db pg_dump -U telecom_user -F c -f /tmp/backup.dump telecom_db
docker cp telecom_db:/tmp/backup.dump C:\\Users\\LENOVO\\Documents\\backup_linkus.dump`,
    esComandos: true
  },
];

export default function Ayuda() {
  const [seccionActiva, setSeccionActiva] = useState('acceso');
  const seccion = SECCIONES.find(s => s.id === seccionActiva);

  const cs = {
    page:    { display:'flex', flexWrap:'wrap', gap:'24px', padding:'24px', maxWidth:'1200px', margin:'0 auto', minHeight:'80vh' },
    sidebar: { width:'220px', minWidth:'220px', display:'flex', flexDirection:'column', gap:'2px' },
    item:    { display:'flex', alignItems:'center', gap:'10px', padding:'9px 14px', borderRadius:'8px', fontSize:'13px', cursor:'pointer', color:'rgba(255,255,255,0.5)', border:'none', background:'none', textAlign:'left', width:'100%' },
    itemA:   { background:'rgba(0,229,255,0.1)', color:'#00E5FF', fontWeight:'600' },
    // En el celular el texto baja debajo del índice: al lado, le quedaban 100 px
    content: { flex:'1 1 300px', minWidth:0, overflowWrap:'anywhere', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'14px', padding:'clamp(16px,5vw,28px)' },
    h1:      { fontSize:'22px', fontWeight:'700', color:'#fff', marginBottom:'20px', display:'flex', alignItems:'center', gap:'10px' },
    pre:     { background:'rgba(0,0,0,0.3)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'8px', padding:'16px', fontSize:'12px', color:'rgba(255,255,255,0.7)', whiteSpace:'pre-wrap', lineHeight:'1.8', fontFamily:"'Courier New', monospace" },
    texto:   { fontSize:'14px', color:'rgba(255,255,255,0.75)', lineHeight:'1.9', whiteSpace:'pre-wrap' },
    tabla:   { width:'100%', borderCollapse:'collapse', marginTop:'20px' },
    th:      { textAlign:'left', padding:'10px 14px', fontSize:'11px', fontWeight:'700', color:'rgba(255,255,255,0.45)', borderBottom:'2px solid rgba(255,255,255,0.1)', textTransform:'uppercase', letterSpacing:'0.5px' },
    td:      { padding:'10px 14px', fontSize:'13px', borderBottom:'1px solid rgba(255,255,255,0.05)', color:'rgba(255,255,255,0.8)' },
    divider: { borderTop:'1px solid rgba(255,255,255,0.06)', margin:'20px 0' },
    version: { fontSize:'11px', color:'rgba(255,255,255,0.25)', marginTop:'24px' },
    cat:     { fontSize:'10px', fontWeight:'700', color:'rgba(255,255,255,0.25)', textTransform:'uppercase', letterSpacing:'1px', padding:'8px 14px 4px' },
  };

  const categorias = [
    { label: 'General', ids: ['acceso','roles'] },
    { label: 'Clientes y Planes', ids: ['clientes','cartera','ventas','cotizaciones'] },
    { label: 'Catálogo', ids: ['catalogo'] },
    // 'infraestructura' se quitó: era el mismo inventario que 'equipos'
    { label: 'Red', ids: ['revendedores','proveedores','equipos','mikrotik'] },
    { label: 'Soporte', ids: ['tickets','agenda'] },
    // Dinero es financiero, no de clientes: es donde se ve lo que entra y lo que sale
    { label: 'Financiero', ids: ['transacciones','reportes'] },
    { label: 'Administración', ids: ['usuarios','backup','comandos'] },
  ];

  return (
    <Layout>
      <div className="pagina" style={cs.page}>
        <div style={cs.sidebar}>
          <div style={{ fontSize:'11px', fontWeight:'700', color:'rgba(255,255,255,0.3)', textTransform:'uppercase', letterSpacing:'1px', padding:'0 14px 8px' }}>
            Manual de uso
          </div>
          {categorias.map(cat => (
            <div key={cat.label}>
              <div style={cs.cat}>{cat.label}</div>
              {SECCIONES.filter(s => cat.ids.includes(s.id)).map(s => (
                <button key={s.id} style={{ ...cs.item, ...(seccionActiva === s.id ? cs.itemA : {}) }}
                  onClick={() => setSeccionActiva(s.id)}>
                  <span>{s.icon}</span>
                  <span>{s.titulo}</span>
                </button>
              ))}
            </div>
          ))}
        </div>

        <div style={cs.content}>
          {seccion && (
            <>
              <h1 style={cs.h1}>
                <span style={{ fontSize:'28px' }}>{seccion.icon}</span>
                {seccion.titulo}
              </h1>
              <div style={cs.divider} />

              {seccion.contenido && (
                seccion.esComandos
                  ? <pre style={cs.pre}>{seccion.contenido}</pre>
                  : <div style={cs.texto}>{seccion.contenido}</div>
              )}

              {seccion.tabla && (
                <>
                  {seccion.contenido && <div style={cs.divider} />}
                  <table style={cs.tabla}>
                    <thead>
                      <tr>{seccion.tabla.cabeceras.map(c => <th key={c} style={cs.th}>{c}</th>)}</tr>
                    </thead>
                    <tbody>
                      {seccion.tabla.filas.map((fila, i) => (
                        <tr key={i}>
                          {fila.map((celda, j) => (
                            <td key={j} style={{ ...cs.td, ...(j === 0 ? { fontWeight:'600', color:'#fff' } : {}) }}>
                              {celda}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}

              <div style={cs.version}>
                Sistema de Gestión Linkus Telecomunicaciones · v2.0 · Junio 2026
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}
